import { createFileRoute, Navigate } from '@tanstack/react-router'

// Redirect shim: the old "В аренде" tab was merged into the registry (#262).
// Keeps old bookmarks and browser history working.
export const Route = createFileRoute('/_app/properties/rented')({
	component: () => <Navigate to="/properties/registry" replace />,
})
